export default __webpack_public_path__ + "static/media/benefit_6@2x.d886b19e.png";